<template>
  <span class="toolOption">
    <button type="button" class="toolbarBtn"
      :class="{active: option}"
      @mousedown.prevent
      @click="onClickOption">
      <img src="~@/assets/img/CITEditor/line_height.png" alt="line height" title="line height" />
    </button>
    <div v-show="option" class="optionGroup">
      <button type="button" class="optionItem"
        v-for="val in lineHeight"
        :key="val"
        :class="{active: val === value}"
        @mousedown.prevent
        @click="onSelectOption($event, val)">{{val}}</button>
    </div>
  </span>
</template>

<script>
export default {
  name: 'LineHeight',
  props: [
    'active',
    'value',
    'option'
  ],
  data () {
    return {
      lineHeight: [
        '1',
        '1.1',
        '1.2',
        '1.3',
        '1.4',
        'default(1.5)',
        '1.6',
        '1.7',
        '1.8',
        '1.9'
      ]
    }
  },
  methods: {
    // open option:: line height
    onClickOption (e) {
      this.$emit('setOption', { name: 'LineHeight', state: true })
    },
    // select option
    onSelectOption (e, val) {
      e.preventDefault()
      const size = val.includes('default') ? '1.5' : val
      this.setLineHeight(size)
      this.$emit('setValue', { name: 'LineHeight', value: val })
    },
    setLineHeight (size) {
      const selection = window.getSelection()
      const range = selection.getRangeAt(0)
      const div = document.createElement('div')
      const lineHeight = Number(size)
      // 선택된 범위 내의 모든 요소에 line-height 스타일 적용
      function applyLineHeight(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          node.style.lineHeight = lineHeight;
        }
        node.childNodes.forEach(child => applyLineHeight(child)) // 모든 자식 노드 순회
      }
      // 빈 태그 정리
      function cleanEmptyTags(node) {
        node.childNodes.forEach(child => {
          if (child && child.style && child.style.lineHeight) {
            const isEmpty = child.textContent.length === 0
            if (isEmpty) {
              child.remove() // 내용이 비어 있는 태그 삭제
            } else {
              cleanEmptyTags(child) // 비어 있지 않으면 하위 노드 검사
            }
          }
        })
      }
      // 선택된 범위에만 line-height 적용
      const contents = range.extractContents() // 선택된 내용 추출
      applyLineHeight(contents) // line-height 적용
      cleanEmptyTags(contents) // 빈 태그 정리
      range.insertNode(contents) // 스타일 적용한 내용 다시 삽입
    }
  }
}
</script>

<style lang="scss" scoped>
.optionItem {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
  line-height: 1;
}
</style>
